var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.message)?_c('v-alert',{staticClass:"py-2 auth-login-alert",attrs:{"type":"error","border":"left","text":"","data-testid":_vm.testId}},[_vm._v(_vm._s(_vm.message))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }